import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { UtilsService } from './utils.service';
import { ConfigService } from './config.service';
import { CookieService } from 'angular2-cookie/core';

@Component({
    selector: '[language-selector]',
    template: `
        <a  *ngIf="language != currentLanguage || displayCurrent"
                (click)="select()" 
                [ngClass]="{active : language === currentLanguage || !displayCurrent}" class="lgSelect lLink">
                    {{(labels ? labels[language] : language) | uppercase}}
        </a>
        `
})
export class LanguageSelectorComponent {
    @Input() resourcePath: string; 
    @Input() currentLanguage: string;
    @Input() displayCurrent: boolean;
    @Input() language: string;
    @Input() labels: Object;
    @Output() onLanguageSelect: EventEmitter<string> = new EventEmitter<string>();

    constructor(private config: ConfigService, private location: Location, private router: Router, private utils: UtilsService, private cookieService: CookieService) {
    }

    select() {
        // Callback for parent component
        this.onLanguageSelect.emit(this.language);
        // Navigate
        let target = this.resourcePath;
        if(!this.config.data.APP.LANGUAGES.SQUASH || this.language != this.config.data.APP.LANGUAGES.PREFERRED)
            target = this.language + target;
        this.router.navigateByUrl(target);
        // Update cookie
        this.cookieService.put('lang', this.language, {expires: this.utils.dateNowPlusDays(this.config.data.APP.LANGUAGES.COOKIE_DAY_AGE)});
    }

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/language-selector.component.ts